import pl from './entries/pl_PL'

const Locale = {
  pl
}

export default Locale